export const TEST_IDS = {
  // Nav
  NAV_HOME: "nav-home",
  NAV_CLUBS: "nav-clubs",
  NAV_MATCHES: "nav-matches",
  NAV_LEADERBOARD: "nav-leaderboard",
  NAV_PROFILE: "nav-profile",
  NAV_ADMIN: "nav-admin",
  NAV_LOGIN: "nav-login-btn",
  NAV_LOGOUT: "nav-logout-btn",
  THEME_TOGGLE: "theme-toggle-btn",

  // Auth
  LOGIN_EMAIL: "login-email-input",
  LOGIN_PASSWORD: "login-password-input",
  LOGIN_SUBMIT: "login-submit-btn",
  REGISTER_NAME: "register-name-input",
  REGISTER_EMAIL: "register-email-input",
  REGISTER_PASSWORD: "register-password-input",
  REGISTER_SUBMIT: "register-submit-btn",

  // Clubs
  CLUB_CARD: "club-card",
  CLUB_BOOK_BTN: "book-court-btn",
  CLUB_REVIEW_BTN: "add-review-btn",

  // Booking
  BOOKING_CALENDAR: "booking-calendar",
  BOOKING_SLOT: "booking-slot",
  BOOKING_CONFIRM: "booking-confirm-btn",
  BOOKING_PAY: "booking-pay-btn",

  // Matches
  MATCH_CREATE: "create-match-btn",
  MATCH_JOIN: "join-match-btn",
  MATCH_CARD: "match-card",
  MATCH_MODE_TOGGLE: "match-mode-toggle",

  // Leaderboard
  LEADERBOARD_TABLE: "leaderboard-table",

  // Profile
  PROFILE_EDIT: "profile-edit-btn",
  PROFILE_SAVE: "profile-save-btn",

  // Home
  HERO_CTA: "hero-cta-btn",
  HERO_SECTION: "hero-section",
};
